import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    mainView: {
      ...CommonStyles.full_flex,
      backgroundColor: colors.background, //viewProfileVisibility ? COLORS.black_70 : COLORS.white,
    },
    webContainer: {
      maxWidth: '66%',
      ...CommonStyles.m_32,
      ...CommonStyles.br_16,
    },
  });

export default makeStyles;
